/**
 * Created by Angelika on 19.09.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import moment from 'moment';

const emptyEPG = {loaded: false, items: []};
const initialState = (function() {
    let state = new Map();
    let start = moment();
    let weekday = start.weekday();
    if (weekday === 0) {
        weekday = 7;
    }
    let end = 8 - weekday;
    let date = start;
    for (let i = 0; i < end; i++) {
        state.set(date.format("YYYY-MM-DD"), emptyEPG);
        date = date.add(1, "days");
    }
    return(state);
})();

export function epg(state = initialState, action) {
    switch (action.type) {
        case actionTypes.EPG_RESET_DAYS:
            let newState = state;
            newState.forEach((value, date) => {
                newState.set(date, emptyEPG);
            });
            return newState;

        case actionTypes.EPG_DAY_REQUEST:
            return state.set(action.date, {
                loaded: false,
                items: [],
                error: null
            });

        case actionTypes.EPG_DAY_SUCCESS:
            return state.set(action.date, {
                loaded: true,
                items: action.items,
                error: null
            });

        case actionTypes.EPG_DAY_FAILED:
            return state.set(action.date, {
                loaded: false,
                items: [],
                error: action.error
            });

        case actionTypes.EPG_TODAY_UPDATE:
            let today = moment().format("YYYY-MM-DD");
            let data = state.get(today);
            let next = {...data, items: _updateTodayEPG(data.items)};
            return state.set(today, next);

        case actionTypes.EPG_UPDATE_START:
        case actionTypes.EPG_UPDATE_STOP:
        default:
            return state;
    }
}

const _updateTodayEPG = (prev) => {
    let now = moment().unix();
    let items = prev;
    if (items) {
        for (let j = 0; j < items.length; j++) {
            let epg = items[j];
            items[j].notactive = now > epg.endTime;
            items[j].current = now >= epg.startTime && now < epg.endTime;
        }
    }
    return items;
};




// WEBPACK FOOTER //
// ./src/reducers/epg.js